import React from 'react';
import { XCircleIcon } from 'lucide-react';
const problems = ['Vous arrivez à l’entraînement sans vrai plan.', 'Vous passez des heures à préparer vos séances avant chaque entraînement.', 'Vous cherchez sans cesse de nouveaux exercices en ligne.', 'Le niveau de compétence de votre groupe varie énormément.', 'Vous ne savez pas comment structurer une progression annuelle.', 'Sessions improvisées en permanence.'];
export function ProblemSection() {
  return <section className="bg-[#0A0A0A] px-5 py-16" data-id="element-170">
      <div className="mx-auto max-w-4xl text-center" data-id="element-171">
        <p className="text-xs font-bold uppercase tracking-[.2em] text-[#d4af37]" data-id="element-172">
          La réalité du coaching
        </p>
        <h2 className="mt-3 font-display text-4xl font-bold uppercase leading-none text-white sm:text-5xl" data-id="element-173">
          Si vous entraînez le rugby, vous connaissez probablement ces
          problèmes.
        </h2>
        <div className="mt-10 grid gap-3 text-left sm:grid-cols-2" data-id="element-174">
          {problems.map(problem => <div key={problem} className="flex gap-3 border border-white/10 bg-[#16161F] p-4" data-id="element-175">
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" data-id="element-176" />
              <p className="text-sm font-semibold leading-snug text-white" data-id="element-177">
                {problem}
              </p>
            </div>)}
        </div>
        <p className="mt-10 font-display text-3xl font-bold uppercase leading-none text-[#d4af37] sm:text-4xl" data-id="element-178">
          Combien de séances allez-vous encore improviser ?
        </p>
      </div>
    </section>;
}